import React from "react";

export default function TextAreaBase(props) {
  return (
    <textarea
      {...props}
      rows="3"
      cols="50"
      style={{ width: "100%", border: "none", outline: "none" }}
    >
      {props.children}
    </textarea>
  );
}
